export default __webpack_public_path__ + "static/media/n6.72da721e.jpg";